export const PRODUCTION = 'prod';
export const STAGING = 'staging';
